export default __webpack_public_path__ + "static/media/cfd2.871ca57b.png";